import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class FeedbackService {

   // Observable string sources
    private feedbackSource = new Subject<any>();

    // Observable string streams
    feedback$ = this.feedbackSource.asObservable();

    emitirFeedback(evento: any) {
        this.feedbackSource.next(evento);
    }

}



// WEBPACK FOOTER //
// ./src/app/utils/feedback/feedback.service.ts